import {OverlayToaster, Intent} from '@blueprintjs/core';

let toaster;
OverlayToaster.createAsync().then(t => { toaster = t; });

const errorToast = args =>
    toaster?.show({
        intent: Intent.WARNING,
        ...args
    });

const successToast = args =>
    toaster?.show({
        intent: Intent.SUCCESS,
        ...args
    });

const infoToast = args =>
    toaster?.show({
        intent: Intent.PRIMARY,
        ...args
    });

export {errorToast, infoToast, successToast};
